import { useFiltersLists } from "features/filters/store/lists";
import { useFilters } from "features/filters/store";
import { TecnologiasItem } from "features/maps/typings";

function useProdutividadeTecnologiasFilters() {
  const { filters, updateFiltroProdutividade } = useFilters();
  const { produtividade } = useFiltersLists();

  const { filtroProdutividade } = filters ?? {};

  const findTecnologiasByOcupacaoSelected = produtividade?.ocupacoes.find(
    (item) => item.codigo === filtroProdutividade?.ocupacao
  );

  const updateTecnologiasSelected = (tecnologiaId?: string) => {
    if (filtroProdutividade?.tecnologias.length) {
      const findElementIndex =
        filtroProdutividade.tecnologias.findIndex(
          (item) => item === tecnologiaId
        );
      const newArray = [...filtroProdutividade.tecnologias];
      if (findElementIndex > -1) {
        if (filtroProdutividade?.tecnologias.length === 1) {
          return;
        }
        newArray.splice(findElementIndex, 1);
      } else {
        newArray.push(tecnologiaId as string);
      }

      const foundCompativeProdutividades =
        filtroProdutividade.produtividades.filter((item) =>
          newArray.includes(item.tecnologiaId as string)
        );

      const checkTodos = findTecnologiasByOcupacaoSelected?.tecnologias
        .filter((item) => item.id !== null)
        .map((i) => {
          return i.id;
        });

      if (!tecnologiaId) {
        updateFiltroProdutividade({
          produtividades: foundCompativeProdutividades,
          ocupacao: filtroProdutividade?.ocupacao,
          tecnologias: checkTodos,
        });
      } else {
        updateFiltroProdutividade({
          produtividades: foundCompativeProdutividades,
          ocupacao: filtroProdutividade?.ocupacao,
          tecnologias: newArray,
        });
      }
    }
  };

  return {
    updateTecnologiasSelected,
    valueTecnologias: filtroProdutividade?.tecnologias ?? [],
    tecnologias: findTecnologiasByOcupacaoSelected?.tecnologias as TecnologiasItem[],
  };
}

export default useProdutividadeTecnologiasFilters;
